<template>
    <Page>
      <NewSlideModal
        v-if="showAddSliderItemModal"
        :showAddSliderItemModal.sync="showAddSliderItemModal"
        :allItems.sync="data.allItems"
        @showLoadFromAPIModal="onShowLoadFromAPIModal"/>
      <LoadFromAPIModal
        v-if="showLoadFromAPIModal"
        :showLoadFromAPIModal.sync="showLoadFromAPIModal"
        :allItems.sync="data.allItems"
        @showAddSliderItemModal="onShowAddSliderItemModal"/>
      <ManageOrderSlider
        :sliderName.sync="sliderName"
        :allItems.sync="data.allItems"
        :selectedIndex.sync="selectedIndex"
        @showAddSliderItemModal="onShowAddSliderItemModal"/>
      <ManageSliderMetadata
        v-if="data.allItems.length"
        :item.sync="data.allItems[selectedIndex]" />
      <EmptyMessage
        v-if="!data.allItems.length">
        <h3>ไม่มีสไลด์</h3>
      </EmptyMessage>
    </Page>
</template>

<script>
import Page from '@/layouts/Page.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

import ManageOrderSlider from './components/ManageOrderSlider.vue';
import ManageSliderMetadata from './components/ManageSliderMetadata.vue';
import NewSlideModal from './components/modals/NewSlideModal.vue';
import LoadFromAPIModal from './components/modals/LoadFromAPIModal.vue';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    sliderName: {
      type: String,
      required: true,
    },
  },
  components: {
    ManageSliderMetadata,
    ManageOrderSlider,
    NewSlideModal,
    LoadFromAPIModal,
    Page,
    EmptyMessage,
  },
  data() {
    return {
      selectedIndex: 0,
      showAddSliderItemModal: false,
      showLoadFromAPIModal: false,
    };
  },
  methods: {
    onShowAddSliderItemModal() {
      this.showAddSliderItemModal = true;
      this.showLoadFromAPIModal = false;
    },
    onShowLoadFromAPIModal() {
      this.showAddSliderItemModal = false;
      this.showLoadFromAPIModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-message-container {
  background: #FFF;
}
</style>
